import { alias, deserialize, serializable } from 'serializr';
import { Base, PageObject } from '@testsigmainc/models';

export class TestSuiteTag extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable(alias('count'))
  public usedCount: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestSuiteTag, input));
  }
}
